import { combineReducers } from 'redux';
import globalReducers from './components/common/redux/reducers/globalReducers';
import listTableReducer from './components/common/list-table/reducers/ListTableReducer';
import { redirectReducer } from './components/common/redux/reducers/redirectReducer';
import userReducer from './components/common/user/redux/reducers/UserReducer';
import impcReducer from './components/common/impc/redux/reducers/ImpcReducer';
import notificationReducer from './components/common/notifications/redux/reducers/NotificationReducer';
import deviceInformationReducer
  from './components/application/mrd-administration/device-information/redux/reducers/DeviceInformationReducer';
import flightInformationReducer
  from './components/application/mrd-administration/flight-information/redux/reducers/FlightInformationReducer';
import DenestImpcsReducer from './components/application/mrd-administration/impc-mapping/redux/reducers/DenestImpcReducer';
import mrdMonitoringReducer from './components/application/mrd-monitoring/redux/reducers/MrdMonitoringReducer';
import HandlersReducer from './components/application/mrd-administration/handlers/redux/reducers/HandlersReducer';
import DeviceSettingsReducer
  from './components/application/mrd-administration/device-settings/redux/reducers/DeviceSettingsReducer';
import ContactManagementReducer
  from './components/application/mrd-administration/contact-management/redux/reducers/MrdContactsReducer';
import NotificationServiceReducer
  from './components/application/mrd-administration/notification-service/redux/reducers/NotificationServiceReducer';
import TranslationsReducer
  from './components/application/mrd-administration/translations/redux/reducers/MrdAppTranslationsReducer';

export default combineReducers({
  global: globalReducers,
  redirect: redirectReducer,
  listing: listTableReducer,
  userData: userReducer,
  impc: impcReducer,
  denestImpc: DenestImpcsReducer,
  notification: notificationReducer,
  mrd: deviceInformationReducer,
  flight: flightInformationReducer,
  mrdMonitoring: mrdMonitoringReducer,
  handlers: HandlersReducer,
  mrdSettings: DeviceSettingsReducer,
  contacts: ContactManagementReducer,
  notificationService: NotificationServiceReducer,
  translations: TranslationsReducer,
});
